/**
 * Normalised error type used everywhere downstream of the HTTP layer.
 *
 * Anything the user might see is funnelled through `AppError` so toast,
 * Sentry and component-level error UIs can all read the same shape.
 */
export type AppErrorKind =
  | 'network'
  | 'unauthorized'
  | 'forbidden'
  | 'not_found'
  | 'conflict'
  | 'validation'
  | 'server'
  | 'unknown';

export class AppError extends Error {
  readonly kind: AppErrorKind;
  readonly status: number | null;
  override readonly cause: unknown;
  readonly details: Readonly<Record<string, unknown>> | null;

  constructor(
    kind: AppErrorKind,
    message: string,
    options: {
      status?: number | null;
      cause?: unknown;
      details?: Record<string, unknown> | null;
    } = {},
  ) {
    super(message);
    this.name = 'AppError';
    this.kind = kind;
    this.status = options.status ?? null;
    this.cause = options.cause ?? null;
    this.details = options.details ?? null;
  }
}
